
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "1024",
    "height": "1024",
    "viewBox": "0 0 1024 1024"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "组_862",
        "data-name": "组 862",
        "transform": "translate(7169 7197)"
      },
      "children": [
        {
          "tag": "rect",
          "attrsMap": {
            "id": "矩形_202",
            "data-name": "矩形 202",
            "width": "1024",
            "height": "1024",
            "transform": "translate(-7169 -7197)",
            "fill": "none"
          }
        },
        {
          "tag": "g",
          "attrsMap": {
            "id": "组_861",
            "data-name": "组 861",
            "transform": "translate(-7236.588 -7275.548)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_211",
                "data-name": "路径 211",
                "d": "M666.833,394.442a278.51,278.51,0,0,0-64.963-14.914c-5.7-.611-11.428-1.03-17.142-1.246a252.986,252.986,0,0,0-58.207,4.193c3.39-47.462,9.14-91.713,16.531-130.274,17-88.706,42.694-147.392,68.473-146.027,24.965,1.318,43.928,58.662,51.99,144.074C667.491,292.558,668.809,341.757,666.833,394.442Z",
                "transform": "translate(74.23 0)",
                "fill": "#d7281d",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_212",
                "data-name": "路径 212",
                "d": "M544.752,379.892a236.19,236.19,0,0,0-30.248,7.858A224.37,224.37,0,0,0,460.574,414,1121.076,1121.076,0,0,1,440.041,299.44c-12.291-100.05-4.5-172.752,23.575-179.7,26.234-6.5,63.622,46.06,97.667,129.879,14.938,36.788,29.241,79.6,41.676,126.081A252.986,252.986,0,0,0,544.752,379.892Z",
                "transform": "translate(55.999 2.582)",
                "fill": "#df631f",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_213",
                "data-name": "路径 213",
                "d": "M465.784,286.521c24.2,25.8,49.438,55.584,74.463,88.311a224.37,224.37,0,0,0-53.93,26.246q-8.122,5.409-15.872,11.632c-2.252,1.809-4.456,3.642-6.625,5.522a249.5,249.5,0,0,0-38.3,41.149,1159.778,1159.778,0,0,1-64.089-99.248c-49.486-86.61-70.522-155.43-48.2-171.962C335.762,171.46,396.46,212.6,465.784,286.521Z",
                "transform": "translate(30.256 15.501)",
                "fill": "#e78f21",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_214",
                "data-name": "路径 214",
                "d": "M381.987,339.4a1168.259,1168.259,0,0,1,102.386,58.1,249.5,249.5,0,0,0-38.3,41.149,241.842,241.842,0,0,0-16.328,25.264,234.594,234.594,0,0,0-21.886,53.607c-31.9-21.251-61.334-42.9-87.4-63.969-83.819-67.73-132.873-129.5-117-153.9C218.794,276.079,290.621,293.784,381.987,339.4Z",
                "transform": "translate(9.703 36.234)",
                "fill": "#c6da5a",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_215",
                "data-name": "路径 215",
                "d": "M330.164,426.546c33.7,1.5,70.593,4.923,109.286,10.362a234.6,234.6,0,0,0-21.886,53.607,226.446,226.446,0,0,0-6.924,38.669,223.036,223.036,0,0,0,.659,46.958c-29.577-5.463-57.728-11.728-83.831-18.556C219.847,529.471,146.978,492,151.686,462.675,156.13,434.979,228.58,422.03,330.164,426.546Z",
                "transform": "translate(0 63.239)",
                "fill": "#6cb83f",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_216",
                "data-name": "路径 216",
                "d": "M778.473,460.421q-4.852,5.894-9.727,11.632c-27.923-38.6-66.017-68.2-108.5-87.185q5.229-6.559,10.661-13.141c95.822-116.2,197.585-190.541,227.282-166.056S874.295,344.222,778.473,460.421Z",
                "transform": "translate(100.699 18.774)",
                "fill": "#d53a83",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_217",
                "data-name": "路径 217",
                "d": "M759.621,300.3c-9.2,38.022-22.126,80.345-38.417,124.536a278.955,278.955,0,0,0-53.415-29.481q-6.631-2.785-13.4-5.2a278.507,278.507,0,0,0-64.963-14.914c19.658-48.48,40.825-92.5,61.645-129.28,42.5-75.1,83.507-119.984,106.9-110.928C782.393,144.494,781.4,210.356,759.621,300.3Z",
                "transform": "translate(86.68 5.487)",
                "fill": "#d5265e",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_218",
                "data-name": "路径 218",
                "d": "M422.715,614.478a229.725,229.725,0,0,0,18.412,36.561c-23.1,5.558-45.545,10.266-67.012,14.123C259.81,685.683,173.5,681.957,165.4,652.225c-7.751-28.439,58.291-72.69,159.431-111.742,25.671-9.919,53.607-19.5,83.172-28.4a222.888,222.888,0,0,0,14.71,102.4Z",
                "transform": "translate(2.635 80.342)",
                "fill": "#6dc1a8",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_219",
                "data-name": "路径 219",
                "d": "M464.039,680.923a212.227,212.227,0,0,0,35.291,25.839c-21.407,19.634-42.622,37.758-63.143,54.086-89.293,71.037-165.337,107.945-186.313,86.035-22.281-23.276,24.474-105.764,108.5-198.639,15.058-16.651,31.314-33.638,48.6-50.684a229.724,229.724,0,0,0,18.412,36.561,238.933,238.933,0,0,0,15.01,21.467A202.423,202.423,0,0,0,464.039,680.923Z",
                "transform": "translate(18.381 97.261)",
                "fill": "#4fa897",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_220",
                "data-name": "路径 220",
                "d": "M472.517,692.989a209.3,209.3,0,0,0,84.106,27.84C495.3,857.092,425.595,952.842,394.712,940.013c-25.013-10.4-17.478-89.161,14.663-192.937,7.846-25.36,17.178-52.217,27.852-79.925A212.229,212.229,0,0,0,472.517,692.989Z",
                "transform": "translate(45.193 111.034)",
                "fill": "#73c6cb",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_221",
                "data-name": "路径 221",
                "d": "M620.938,702.29c-.335,26.39-1.414,51.642-3.174,75.3-7.81,105.585-28.966,179.317-55.619,179.964-30.02.743-57.644-91.593-68.725-218.561q-1.42-16.334-2.48-33.386a207.864,207.864,0,0,0,22.389,6.121,187.833,187.833,0,0,0,61.31,3.067A162.643,162.643,0,0,0,620.938,702.29Z",
                "transform": "translate(67.188 117.989)",
                "fill": "#659eb7",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_222",
                "data-name": "路径 222",
                "d": "M733.071,897.017c-21.036,12.147-71.9-33.721-129.136-111.347-14.1-19.131-28.594-40.19-43.125-62.8a162.643,162.643,0,0,0,46.3-12.506,155.26,155.26,0,0,0,41.376-26.7,2.049,2.049,0,0,1,.18-.156,152.412,152.412,0,0,0,20.089-22.042c7.487,14.531,14.483,28.774,20.94,42.6C736.821,804.825,756.1,883.732,733.071,897.017Z",
                "transform": "translate(81.017 109.91)",
                "fill": "#658fc3",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_223",
                "data-name": "路径 223",
                "d": "M832.454,753.637c-11.8,18.939-74.259,2.983-157.275-36.465-13.2-6.277-26.917-13.141-41.029-20.556a152.41,152.41,0,0,0,20.089-22.042,168.575,168.575,0,0,0,26.51-53.3,176.858,176.858,0,0,0,5.63-26.019c12.674,9.116,24.737,18.149,36.105,26.989C799.319,682.049,844.7,734,832.454,753.637Z",
                "transform": "translate(95.533 96.805)",
                "fill": "#8880b4",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_224",
                "data-name": "路径 224",
                "d": "M847.573,607.12c-2.348,18.053-54.565,27.492-132.754,27.2-13.2-.036-27.157-.359-41.736-.97a176.849,176.849,0,0,0,5.63-26.019,172.7,172.7,0,0,0,1.066-38.777,151.3,151.3,0,0,0-6.9-34.309c20.221,4.253,39.208,8.745,56.674,13.381C803.274,567.2,849.885,589.318,847.573,607.12Z",
                "transform": "translate(103.198 84.73)",
                "fill": "#c45e9e",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_225",
                "data-name": "路径 225",
                "d": "M733.763,558.348c-15.154,6.972-31.853,14.016-49.774,20.928a151.306,151.306,0,0,0-6.9-34.309,129.261,129.261,0,0,0-8.637-20.437,113.716,113.716,0,0,0-13.381-19.993c-1.138-1.366-2.3-2.7-3.462-3.989,18.017-4.5,35.231-8.314,51.307-11.368,66.329-12.614,113.347-12.494,118.187,2.947C825.728,506.9,790.713,532.137,733.763,558.348Z",
                "transform": "translate(98.989 74.013)",
                "fill": "#60328f",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_226",
                "data-name": "路径 226",
                "d": "M707.962,499.874c-10.051,11.033-21.622,22.9-34.464,35.351a113.718,113.718,0,0,0-13.381-19.993c-1.138-1.366-2.3-2.7-3.462-3.989-3.258-3.63-6.625-7.008-10.062-10.146a135.607,135.607,0,0,0-20.473-15.525c13.86-9.571,27.049-18.172,39.3-25.683,44.683-27.361,76.966-40.035,84.454-30.858C756.993,437.75,740.306,464.428,707.962,499.874Z",
                "transform": "translate(93.944 63.319)",
                "fill": "#914194",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_227",
                "data-name": "路径 227",
                "d": "M671.175,466.2c-5.259,12.494-11.56,26.306-18.831,41.208a135.609,135.609,0,0,0-20.473-15.525,131.432,131.432,0,0,0-17.358-9,129.779,129.779,0,0,0-17.454-6.014c8.457-10.853,16.555-20.82,24.186-29.78,31.853-37.447,55.631-57.56,64.46-52.038C693.888,400.186,687.862,426.517,671.175,466.2Z",
                "transform": "translate(88.192 57.003)",
                "fill": "#d53a83",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_228",
                "data-name": "路径 228",
                "d": "M626.8,449.67c-1.569,11.189-3.821,23.252-6.732,35.794a129.772,129.772,0,0,0-17.454-6.014,126.45,126.45,0,0,0-16.975-3.27c-3.821-.479-7.607-.767-11.356-.886-1.773-.048-3.546-.072-5.295-.048.815-3.031,1.641-6.026,2.492-8.961,2.587-8.972,5.355-17.5,8.23-25.456,13.513-37.435,29.325-62.136,39.831-59.477C629.785,383.94,632.132,411.8,626.8,449.67Z",
                "transform": "translate(82.636 54.43)",
                "fill": "#d5265e",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_229",
                "data-name": "路径 229",
                "d": "M591.316,475.631c-3.821-.479-7.607-.767-11.356-.887-1.773-.048-3.546-.072-5.295-.048a115.786,115.786,0,0,0-33.578,5.259c-1.629-27.361-.611-51.714,2.516-69.036,2.947-16.292,7.739-26.39,13.944-26.965,9.763-.9,20.413,22.006,27.84,56.326C587.734,451.062,589.747,462.981,591.316,475.631Z",
                "transform": "translate(76.962 54.978)",
                "fill": "#d7281d",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_230",
                "data-name": "路径 230",
                "d": "M561.243,473.764a102.63,102.63,0,0,0-26.534,8.913,82.463,82.463,0,0,0-11.943,7.247q-2.156,1.581-4.277,3.342c-4.792-12.9-8.721-25.216-11.716-36.417-8.266-30.966-9.344-53.523-1.318-56.841C516.261,395.552,539.956,427.5,561.243,473.764Z",
                "transform": "translate(68.976 58.079)",
                "fill": "#df631f",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_231",
                "data-name": "路径 231",
                "d": "M541.713,477.231a82.464,82.464,0,0,0-11.943,7.247q-2.156,1.581-4.277,3.342a102.511,102.511,0,0,0-10.853,10.386,114.036,114.036,0,0,0-7.918,9.775c-6.385-7.81-12.183-15.441-17.31-22.7-19.8-28.055-29.421-50.54-22.689-56.6,6.133-5.522,24.366,3.893,47.054,22.725C522.57,458.7,532.034,467.42,541.713,477.231Z",
                "transform": "translate(61.973 63.525)",
                "fill": "#e78f21",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_232",
                "data-name": "路径 232",
                "d": "M519.6,491.047a114.627,114.627,0,0,0-18.412,27.432c-1.306,2.731-2.516,5.534-3.594,8.4-5.858-4.121-11.4-8.206-16.567-12.207-28.4-22.006-45.281-41.28-40.765-48.5,4.169-6.66,25.54-1.414,54.11,11.955C502.3,481.835,510.782,486.172,519.6,491.047Z",
                "transform": "translate(57.014 70.684)",
                "fill": "#f0ea4e",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_233",
                "data-name": "路径 233",
                "d": "M504.382,510.586c-1.306,2.731-2.516,5.534-3.594,8.4a99.37,99.37,0,0,0-6.133,26.079c-.192,2.037-.311,4.073-.359,6.121-3.318-1.114-6.553-2.252-9.691-3.39-38.07-13.8-63.49-28.954-61.058-37.818,2.2-8.014,26.618-8.781,60.675-3.2C490.63,507.818,497.374,509.088,504.382,510.586Z",
                "transform": "translate(53.818 78.578)",
                "fill": "#6cb83f",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_234",
                "data-name": "路径 234",
                "d": "M500.3,578.558c-2.024.252-4.037.491-6,.707-39.519,4.372-68.353,2.132-70.054-6.672-1.677-8.637,23.18-21.143,60.208-31.721,3.258-.922,6.613-1.845,10.051-2.731-.192,2.037-.312,4.073-.359,6.121a85.461,85.461,0,0,0,4.911,31.014C499.437,576.378,499.856,577.468,500.3,578.558Z",
                "transform": "translate(53.972 85.5)",
                "fill": "#6dc1a8",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_235",
                "data-name": "路径 235",
                "d": "M515.806,602.861c-2.5,1.486-4.959,2.9-7.379,4.265-30.823,17.382-54.649,25.348-59.453,18.544-5-7.08,11.943-28.151,40.586-52.541q2.336-1.977,4.756-3.989c.383,1.1.8,2.192,1.246,3.282a93.269,93.269,0,0,0,12.914,22.305c1.4,1.809,2.863,3.522,4.384,5.163C513.817,600.921,514.8,601.915,515.806,602.861Z",
                "transform": "translate(58.71 91.636)",
                "fill": "#4fa897",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_236",
                "data-name": "路径 236",
                "d": "M532.42,612.383c-.743,1.33-1.521,2.659-2.324,3.989-.012.024-.024.036-.036.06-15.944,26.5-35.039,44.275-42.634,39.7-7.4-4.444-1.186-28.391,13.836-54.086.419-.731.851-1.449,1.282-2.18,1.042-1.725,2.084-3.414,3.151-5.055.958,1.03,1.941,2.025,2.947,2.971a65.441,65.441,0,0,0,21.8,13.872C531.09,611.9,531.749,612.156,532.42,612.383Z",
                "transform": "translate(65.875 96.716)",
                "fill": "#73c6cb",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_237",
                "data-name": "路径 237",
                "d": "M554.778,613.458a1.77,1.77,0,0,1-.012.252c-2.24,30.859-11.213,55.344-20.065,54.709-8.625-.623-13.944-24.977-12.111-54.829.036-.731.1-1.461.144-2.192.06-.85.132-1.689.2-2.528.647.252,1.306.5,1.977.731A76.356,76.356,0,0,0,554.778,613.458Z",
                "transform": "translate(73.381 99.499)",
                "fill": "#659eb7",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_238",
                "data-name": "路径 238",
                "d": "M573.385,665.358c-8.29,1.521-19.287-20.556-24.557-49.306-.144-.779-.276-1.557-.407-2.336a111.306,111.306,0,0,0,29.5-5.7,2.741,2.741,0,0,0,.443-.144c.132.695.264,1.4.4,2.108.036.18.072.371.108.563C584.13,639.3,581.686,663.837,573.385,665.358Z",
                "transform": "translate(78.565 99.301)",
                "fill": "#658fc3",
                "opacity": "0.87"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_239",
                "data-name": "路径 239",
                "d": "M608.377,653.277c-7.319,3.282-22.569-14.854-34.081-40.514-.132-.3-.276-.611-.407-.91-.287-.659-.575-1.318-.839-1.965a2.731,2.731,0,0,0,.443-.144A167.844,167.844,0,0,0,599.656,598.4c.383.815.767,1.641,1.138,2.48C612.306,626.539,615.7,649.994,608.377,653.277Z",
                "transform": "translate(83.44 97.427)",
                "fill": "#8880b4",
                "opacity": "0.87"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  